/** Global commission multiplier for rate analysis pricing. */
export const COMMISSION_PRICE_MULTIPLIER = 0.82;

export const COMMISSION_PRICE_LABEL = "Exclusive of commission";

export const getCommissionPrice = (price) => {
  const numericPrice = parseFloat(price);
  if (Number.isNaN(numericPrice) || numericPrice <= 0) {
    return null;
  }
  return parseFloat((numericPrice * COMMISSION_PRICE_MULTIPLIER).toFixed(2));
};
